import React from 'react';
import DatePicker from 'react-datepicker';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import 'react-datepicker/dist/react-datepicker.css'; 
import './date-range-picker.css';

type IProps = {
  disabled?: boolean;
  placeHolderText: string;
  maxDate?: Date;
  minDate?: Date;
  startDate: Date | null; // Now fully controlled by the parent
  endDate: Date | null; // Now fully controlled by the parent
  onDateChange: (dates: [Date | null, Date | null]) => void;
};

export const DateRangePicker: React.FC<IProps> = ({ disabled, placeHolderText, maxDate, minDate, startDate, endDate, onDateChange }) => {
  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      maxDate={maxDate}
      minDate={minDate}
      disabled={disabled}
      selected={startDate}
      onChange={onDateChange} // Parent directly handles state updates
      isClearable
      showIcon
      icon={<CalendarTodayOutlinedIcon />}
      placeholderText={placeHolderText}
      calendarClassName="date-picker-container"
      toggleCalendarOnIconClick
      dateFormat="MM/dd/yyyy"
    />
  );
};

export default DateRangePicker;
